/**
 * Reports Service
 * API calls for financial and business reports
 */

import { api } from './api.js';
import type {
  SalesReportEntry,
  IncomeStatement,
  ExpenseReportEntry,
  CustomerReportEntry,
  ProductSalesEntry,
  TaxReportEntry,
  AgedReceivablesEntry,
  SalesReportParams,
  IncomeStatementParams,
  ExpenseReportParams,
  CustomerReportParams,
  ProductSalesParams,
  TaxReportParams,
  AgedReceivablesParams,
} from '../types/reports.js';

export const reportsService = {
  async getSalesReport(params: SalesReportParams): Promise<SalesReportEntry[]> {
    const response = await api.get<SalesReportEntry[]>('/reports/sales', { params });
    return response.data;
  },

  async getIncomeStatement(params: IncomeStatementParams): Promise<IncomeStatement> {
    const response = await api.get<IncomeStatement>('/reports/income-statement', { params });
    return response.data;
  },

  async getExpenseReport(params: ExpenseReportParams): Promise<ExpenseReportEntry[]> {
    const response = await api.get<ExpenseReportEntry[]>('/reports/expenses', { params });
    return response.data;
  },

  async getCustomerReport(params?: CustomerReportParams): Promise<CustomerReportEntry[]> {
    const response = await api.get<CustomerReportEntry[]>('/reports/customers', { params });
    return response.data;
  },

  async getProductSalesReport(params: ProductSalesParams): Promise<ProductSalesEntry[]> {
    const response = await api.get<ProductSalesEntry[]>('/reports/product-sales', { params });
    return response.data;
  },

  async getTaxReport(params: TaxReportParams): Promise<TaxReportEntry[]> {
    const response = await api.get<TaxReportEntry[]>('/reports/tax', { params });
    return response.data;
  },

  async getAgedReceivables(params?: AgedReceivablesParams): Promise<AgedReceivablesEntry[]> {
    const response = await api.get<AgedReceivablesEntry[]>('/reports/aged-receivables', { params });
    return response.data;
  },

  async exportReport(
    reportType: 'sales' | 'income-statement' | 'expenses' | 'customers' | 'product-sales' | 'tax' | 'aged-receivables',
    params: Record<string, unknown>,
    format: 'pdf' | 'csv' | 'xlsx' = 'pdf'
  ): Promise<Blob> {
    const response = await api.get<Blob>(`/reports/${reportType}/export`, {
      params: { ...params, format },
      responseType: 'blob',
    });
    return response.data;
  },
};
